<template>
  <div class="flex flex-col gap-4">
    <BittsFormLabel :label="{ title: label }" :for="fieldId" />
    <slot :id="fieldId" />
    <span v-if="dangerHint" class="text-sm text-danger-text">
      {{ dangerHint }}
    </span>
    <span v-else-if="hint" class="text-sm text-neutral-text-placeholder">
      {{ hint }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { BittsFormLabel } from '@crossbeam/bitts';

import { useId } from 'vue';

defineProps<{
  label: string;
  hint?: string;
  dangerHint?: string;
}>();

const fieldId = useId();
</script>
